import React, { useState } from 'react';
import { useGlobalContext } from '../../contexts/GlobalContext';
import { useForm } from 'react-hook-form';

//Modelos
import SearchGuiaModel from '../../models/SearchGuia';

//Servicios

//Componentes
import SearchGuias from './SearchGuias';

function SearchGuiasContainer() {
    const {
        token,
        masters,
        tablePage,
        setTablePage,
        buildSelectOptions,
        SearchParameters,
        dispatchSearchParameters,
    } = useGlobalContext();
    const FormMethods = useForm();

    async function onSearch(data) {
        const GuiasforSearch = new SearchGuiaModel(data);

        // console.log(GuiasforSearch);

        dispatchSearchParameters({
            type: 'GUIAS',
            payload: {
                token,
                ...GuiasforSearch,
                pagina: tablePage,
                cantidad: 10,
            },
        });

        setTablePage(1);
    }

    return (
        <SearchGuias
            functions={{
                ...FormMethods,
                onSearch,
                buildSelectOptions,
            }}
            states={{
                masters,
                SearchParameters,
            }}
        />
    );
}

export default SearchGuiasContainer;
